import { render, staticRenderFns } from "./Anamnese.vue?vue&type=template&id=ab133fc4&scoped=true&"
import script from "./Anamnese.vue?vue&type=script&lang=js&"
export * from "./Anamnese.vue?vue&type=script&lang=js&"
import style0 from "./Anamnese.vue?vue&type=style&index=0&id=ab133fc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab133fc4",
  null
  
)

export default component.exports